import { PageLayout } from '@app/pages/layout/PageLayout'
import { useClient } from '@based/sdk/react'
import { useEffect, useState } from 'react'
import { useTranslations } from '@i18n/useLanguage'
import Row from '@app/components/layout/Row'
import useTransform from '@app/util/useTransform'
import Column from '@app/components/layout/Column'
import { TabContent } from './sections/TabContent'
import { ItemListCard } from '@app/components/blocks/card/ItemListCard'
import useMediaQuery from '@app/util/useMediaQuery'
import { useLocation } from 'wouter'
import { ServiceProviderConceptViewModel } from 'functions/app/service-provider-concept/view'
import { ServiceProviderConceptPageHeaderCard } from './ServiceProviderConceptPageHeaderCard'
import { pages } from '@app/util/links'

export type ServiceProviderConceptPageProps = {
  slug: string
}

export const ServiceProviderConceptPage = ({
  slug,
}: ServiceProviderConceptPageProps) => {
  const client = useClient()
  const [serviceProviderConcept, setServiceProviderConcept] =
    useState<ServiceProviderConceptViewModel>()
  const t = useTranslations().app.serviceProviderConceptPage
  const transformStyle = useTransform()
  const isMobile = useMediaQuery()
  const [, setLocation] = useLocation()

  useEffect(() => {
    const subscription = client
      .query('view-service-provider-concept', { slug })
      .subscribe((p) => setServiceProviderConcept(p))

    return () => {
      subscription()
    }
  }, [client, slug])

  if (!serviceProviderConcept) {
    return <div>{t.loading}</div>
  }

  return (
    <PageLayout gap="2rem">
      <Row
        gap="3rem"
        style={{
          alignItems: 'flex-start',
          ...transformStyle,
        }}
      >
        <Column style={{ flex: 1, width: '100%' }} gap="1.5rem">
          <ServiceProviderConceptPageHeaderCard
            serviceProviderConcept={serviceProviderConcept}
          />
          <TabContent serviceProviderConcept={serviceProviderConcept} />
        </Column>

        {!isMobile && (
          <Column style={{ flex: '0 1 23rem', minWidth: '23rem' }}>
            <ItemListCard
              title={t.offeredBy}
              items={serviceProviderConcept.serviceProviders.map((sp) => ({
                title: sp.name,
                image: sp.avatar?.src,
                onClick: () => setLocation(`${pages.serviceProvider(sp.slug)}`),
              }))}
            />
          </Column>
        )}
      </Row>
    </PageLayout>
  )
}
